import { z } from "zod";

const Locale = z
  .string()
  .regex(/^[a-z]{2}$/)
  .optional();

/** Sohbet fotoğrafı yolu: <sohbet uuid>/<dosya> (kova chat-media); API yolun sohbete ait ve nesnenin var olduğunu doğrular */
const CHAT_PATH = /^[0-9a-f-]{36}\/[A-Za-z0-9._-]{1,200}$/;

/**
 * POST /v1/conversations/:id/messages (K-044, K-148): metin (`kind` yok ya da "text"), fotoğraf (önce Storage'a
 * yüklenir, burada yol bildirilir) ya da konum (gönderenin onayladığı tam koordinat).
 */
export const SendMessageBody = z.union([
  z.object({
    kind: z.literal("text").optional(),
    body: z.string().trim().min(1).max(4000),
    bodyLocale: Locale,
  }),
  z.object({
    kind: z.literal("image"),
    path: z.string().regex(CHAT_PATH),
    /** isteğe bağlı alt yazı */
    body: z.string().trim().max(500).optional(),
  }),
  z.object({
    kind: z.literal("location"),
    latitude: z.number().min(-90).max(90),
    longitude: z.number().min(-180).max(180),
  }),
]);
export type SendMessageBody = z.infer<typeof SendMessageBody>;

/** POST /v1/messages/:id/report — K-044 işaretleme */
export const ReportMessageBody = z.object({
  reason: z.enum(["abuse", "spam", "off_platform_payment", "personal_info", "other"]),
});

export type MessageKind = "text" | "image" | "location";

export interface ConversationView {
  id: string;
  taskId: string | null;
  status: "open" | "closed";
  /** karşı taraf(lar)ın görünen adı */
  with: string[];
  lastMessage: {
    body: string | null;
    kind: MessageKind;
    at: string;
    mine: boolean;
  } | null;
  unread: number;
  /** karşı tarafın en son okuduğu an; son mesajımdan sonraysa "Görüldü" (K-166) */
  otherReadAt: string | null;
}

export interface MessageView {
  id: string;
  kind: MessageKind;
  body: string | null;
  /** kind=image: sohbet fotoğrafı (kova chat-media, özel; istemci imzalı adres ister) */
  image: { bucket: "chat-media"; path: string } | null;
  /** kind=location */
  location: { latitude: number; longitude: number } | null;
  mine: boolean;
  system: boolean;
  createdAt: string;
}
